import $ from "jquery";
import isTouchDevice from '../lib/is-mobile';
import ScrollTrigger from "gsap/ScrollTrigger";

// the "endpoint" variable is declared in the header : 
{/* <script type="text/javascript">
    var endpoint = "<?php echo admin_url('admin-ajax.php'); ?>";
</script> */}


const filterAjax = () => {
	document.addEventListener('DOMContentLoaded', function () {
    
		
        $('.js-filter-item').on('click', function(e) {
            e.preventDefault();
            $.ajax({
              type: 'POST',
              // url: '../wp-admin/admin-ajax.php',
              url: endpoint,
              dataType: 'html',
              data: {
                action: 'filter_actualites',
                category: $(this).data('slug'),
                type: $(this).data('type'),
              },
              success: function(res) {
                $(".pagination-blog").hide();
                $(".article-blog__grid").hide().html(res).fadeIn(800);
                setTimeout(() => {
                  ScrollTrigger.refresh();
                }, 1000);
              }
            })

            if (isTouchDevice() && window.matchMedia("(max-width: 1023px)").matches) {
            let activeFilter = $("#js_active-filter"); 
            let filterContentToGrab = $(this).text();
            activeFilter.text(filterContentToGrab);
            }

            $('#js-filter-reset').addClass('active')
            

        });


        $('#js-filter-reset').on('click', function(e) {
          e.preventDefault();
          $.ajax({
            type: 'POST',
            url: endpoint,
            dataType: 'html',
            data: {
              action: 'reset_actualites',
              type: $(this).data('type'),
            },
            success: function(res) {
              $(".pagination-blog").fadeIn(800);
              $('#js-filter-reset').removeClass('active');
              $('.js-filter-item').removeClass('activeClass');
              $(".article-blog__grid").hide().html(res).fadeIn(800);   
              setTimeout(() => {
                ScrollTrigger.refresh();
              }, 1000);

              if (isTouchDevice() && window.matchMedia("(max-width: 1023px)").matches) {
                let activeFilter = $("#js_active-filter"); 
                activeFilter.text('Filtrer par');
                }
            }
          })
        })
	})
}

export default filterAjax








